/* ==========================================================================
   Mijn Huisdier Cadeau — Variantkeuze open laten
   - Op de productpagina is bij binnenkomst nog geen kleur/maat gekozen.
   - De klant kiest zelf; pas als alle opties gekozen zijn, kan het product
     in de winkelwagen.
   - Komt de klant binnen via een link met ?variant=..., dan werkt alles
     zoals standaard (variant is dan bewust gekozen).
   ========================================================================== */
(() => {
  if (window.__mhcVariantKeuze) return;
  window.__mhcVariantKeuze = true;

  try {
    if (new URL(window.location.href).searchParams.has('variant')) return;
  } catch (e) {
    return;
  }

  /** Posities (1, 2, ...) van opties die de klant zelf heeft gekozen */
  const chosen = new Set();
  let applying = false;
  let originalLabel = null;

  const getPicker = () => document.querySelector('variant-picker[data-template-product-match="true"]');

  const positionOf = (el) => {
    const id = el && el.dataset ? el.dataset.inputId : '';
    const pos = parseInt(String(id || '').split('-')[0], 10);
    return isNaN(pos) ? null : pos;
  };

  /** Alle optiegroepen in de kiezer, met positie en naam */
  const groups = (picker) => {
    const out = [];
    picker.querySelectorAll('fieldset.variant-option').forEach((fs) => {
      const input = fs.querySelector('input[data-input-id]');
      const legend = fs.querySelector('legend');
      const name = legend ? (legend.childNodes[0] ? legend.childNodes[0].textContent : legend.textContent) : '';
      if (input) out.push({ el: fs, type: 'buttons', pos: positionOf(input), name: name.trim() });
    });
    picker.querySelectorAll('.variant-option--dropdowns').forEach((wrap) => {
      const opt = wrap.querySelector('option[data-input-id]');
      const label = wrap.querySelector('label');
      if (opt) out.push({ el: wrap, type: 'select', pos: positionOf(opt), name: label ? label.textContent.trim() : '' });
    });
    return out;
  };

  /** Korte, leesbare naam: 'Kleur sweater' -> 'kleur', 'Maat hoodie' -> 'maat' */
  const shortName = (name) => {
    const n = String(name || '').toLowerCase().trim();
    return n.split(/\s+/)[0] || n;
  };

  const section = (picker) => picker.closest('.shopify-section') || document;

  const addButton = (picker) => {
    const sec = section(picker);
    return sec.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
  };

  function clearGroup(g) {
    if (g.type === 'buttons') {
      g.el.querySelectorAll('input[type="radio"]').forEach((i) => {
        if (i.checked) i.checked = false;
        if (i.hasAttribute('checked')) i.removeAttribute('checked');
      });
      const valueEl = g.el.querySelector('.variant-option__swatch-value');
      if (valueEl && valueEl.textContent !== '') valueEl.textContent = '';
    } else {
      const select = g.el.querySelector('select');
      if (!select) return;
      let ph = select.querySelector('option[data-mhc-placeholder]');
      if (!ph) {
        ph = document.createElement('option');
        ph.value = '';
        ph.disabled = true;
        ph.dataset.mhcPlaceholder = 'true';
        ph.textContent = 'Kies een ' + shortName(g.name);
        select.insertBefore(ph, select.firstChild);
      }
      select.querySelectorAll('option[selected]').forEach((o) => o.removeAttribute('selected'));
      ph.selected = true;
    }
    g.el.classList.add('mhc-keuze-open');
  }

  function apply() {
    const picker = getPicker();
    if (!picker || applying) return;
    applying = true;
    try {
      const all = groups(picker);
      const missing = all.filter((g) => g.pos !== null && !chosen.has(g.pos));

      all.forEach((g) => {
        if (missing.includes(g)) clearGroup(g);
        else g.el.classList.remove('mhc-keuze-open');
      });

      const btn = addButton(picker);
      if (!btn) return;
      const label = btn.querySelector('.add-to-cart-text__content');
      const sec = section(picker);
      const accelerated = sec.querySelector('[ref="acceleratedCheckoutButtonContainer"], .shopify-payment-button');

      if (missing.length) {
        if (label && originalLabel === null) originalLabel = label.textContent;
        const names = missing.map((g) => shortName(g.name));
        const text = 'Kies eerst ' + (names.length > 1 ? names.slice(0, -1).join(', ') + ' en ' + names.slice(-1) : names[0]);
        if (label && label.textContent !== text) label.textContent = text;
        // Niet echt 'disabled' maken: dan kan de klant nog klikken en tonen we wat er ontbreekt
        if (btn.dataset.mhcBlocked !== 'true') btn.dataset.mhcBlocked = 'true';
        if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
        if (accelerated && !accelerated.hasAttribute('hidden')) accelerated.setAttribute('hidden', 'true');
        // Geen ?variant= in de adresbalk zolang de keuze niet compleet is
        try {
          const url = new URL(window.location.href);
          if (url.searchParams.has('variant')) {
            url.searchParams.delete('variant');
            history.replaceState(history.state, '', url.toString());
          }
        } catch (e) {}
      } else if (btn.dataset.mhcBlocked) {
        // Alles gekozen: knop terugzetten (het thema werkt hem daarna verder bij)
        delete btn.dataset.mhcBlocked;
        btn.removeAttribute('aria-disabled');
        if (label && originalLabel !== null) label.textContent = originalLabel;
        if (accelerated) accelerated.removeAttribute('hidden');
      }
    } finally {
      applying = false;
    }
  }

  /* Keuze van de klant registreren vóórdat het thema de wijziging verwerkt */
  document.addEventListener(
    'change',
    (event) => {
      const picker = getPicker();
      const target = event.target;
      if (!picker || !(target instanceof HTMLElement) || !picker.contains(target)) return;
      let pos = null;
      if (target instanceof HTMLSelectElement) {
        const opt = target.options[target.selectedIndex];
        if (opt) {
          // placeholder verwijderen en de gekozen optie als 'selected' markeren voor het thema
          target.querySelectorAll('option[data-mhc-placeholder]').forEach((o) => o.remove());
          pos = positionOf(opt);
        }
      } else {
        pos = positionOf(target);
      }
      if (pos !== null) chosen.add(pos);
      apply();
    },
    true
  );

  /* Klik op een geblokkeerde knop: uitleggen wat er nog gekozen moet worden.
     Op window (capture) zodat dit vóór de thema-handlers loopt. */
  window.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest && event.target.closest('button[name="add"]');
      if (!btn || btn.dataset.mhcBlocked !== 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const picker = getPicker();
      const open = picker && picker.querySelector('.mhc-keuze-open');
      if (open) {
        open.scrollIntoView({ behavior: 'smooth', block: 'center' });
        open.classList.remove('mhc-keuze-flash');
        void open.offsetWidth;
        open.classList.add('mhc-keuze-flash');
      }
    },
    true
  );

  window.addEventListener(
    'submit',
    (event) => {
      const picker = getPicker();
      const btn = picker && addButton(picker);
      if (btn && btn.dataset.mhcBlocked === 'true' && event.target === btn.form) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /* Kies je eerst een maat (nog geen kleur), dan de fotogalerij niet laten
     wisselen naar een kleurfoto die de klant niet gekozen heeft. */
  const isColorGroup = (g) =>
    g.el.classList.contains('variant-option--swatches') || /^(kleur|color|colour)/.test(shortName(g.name));

  document.addEventListener(
    'variant:update',
    (event) => {
      const picker = getPicker();
      const html = event.detail && event.detail.data && event.detail.data.html;
      if (!picker || !html || !picker.contains(event.target)) return;
      const colorMissing = groups(picker).some((g) => g.pos !== null && !chosen.has(g.pos) && isColorGroup(g));
      if (colorMissing) {
        const gallery = html.querySelector('media-gallery');
        if (gallery) gallery.remove();
      }
    },
    true
  );

  /* Het thema ververst de kiezer en knop na elke keuze: daarna opnieuw toepassen */
  const start = () => {
    const picker = getPicker();
    if (!picker) return;
    apply();
    new MutationObserver(() => apply()).observe(section(picker), {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['checked', 'selected', 'disabled', 'aria-disabled', 'data-mhc-blocked'],
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
